 <template>
  <client-only>
    <div class="map-wrapper">
      <GmapMap
        id="map"
        :center="{ lat: destinationLatitude, lng: destinationLongitude }"
        :zoom="15"
        map-type-id="terrain"
      >
        <GmapMarker
        v-for="(location, index) in locations"
          :position="{ lat: location.lat, lng: location.lng }"
          :key="index"
          :clickable="true"
          :draggable="true"
        />
      </GmapMap>
      <CompanyLocation
        v-if="address"
        :address="address"
        :destinationLatitude="destinationLatitude"
        :destinationLongitude="destinationLongitude"
      />
    </div>
  </client-only>
</template>

<script>
import drushim_lodash from 'lodash';
import CompanyLocation from '@/components/Company/CompanyLocation';

export default {
  components: {
    CompanyLocation,
  },

  data() {
    return {
      originLatitude: undefined,
      originLongitude: undefined,
    };
  },

  props: {
    destinationLatitude: {
      type: Number,
    },

    destinationLongitude: {
      type: Number,
    },

    address: {
      type: String,
    },
  },

  computed: {
    locations() {
      let locations = [];
      let location = {};
      location.lat = this.destinationLatitude;
      location.lng = this.destinationLongitude;

      locations.push(location);
      location = {};
      if (!drushim_lodash.isNil(this.originLatitude) && !drushim_lodash.isNil(this.originLongitude)) {
        location.lat = this.originLatitude;
        location.lng = this.originLongitude;
        locations.push(location);
      }

      return locations;
    },
  },
};
</script>

<style lang="scss" scoped>
#map {
  width: 100%;
  height: 100%;
  position: relative;
}

.map-wrapper {
  height: 100%;
  position: relative;
}

@media screen and (max-width: 600px) {
  .map-wrapper {
    height: 400px;
  }
}
</style>

